import React, { useEffect, useRef, useState } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import $ from "jquery";

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
const Swal = require('sweetalert2');

const defaultValue = new Date().toLocaleDateString("en-CA");

const escapeHtml = (value = "") =>
    String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");

const formatJobDescription = (value = "") => {
    const raw = String(value).trim();
    if (!raw) return "";

    const normalized = raw
        .replace(/\s*\/\/\s*/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const points = normalized
        .replace(/(\d+[\.\)])\s*/g, "\n$1 ")
        .split("\n")
        .map((item) => item.trim())
        .filter(Boolean);

    return points.map((item) => escapeHtml(item)).join("<br/>");
};


function Joblist() {
    const [tableData, setTableData] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [fromdate, setfromdate] = useState(defaultValue);
    const [todate, settodate] = useState("");
    const [branchname, setbranchname] = useState("");
    const [status, setstatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const accesstoken = localStorage.getItem("token");
    const navigate = useNavigate();
    const tableRef = useRef(null);
    const dataTableInstance = useRef(null);

    const Jobposting = () => navigate("/addjob");
    const Editjobposting = (id) => navigate("/editjob/" + id);

    const resetSearchFields = () => {
        setfromdate(defaultValue);
        settodate("");
        setbranchname("");
        setstatus("");
    };

    const loadBranchOptions = () => {
        axios.get(baseurladdress + "getbranchname", {
            headers: { Authorization: `Bearer ${accesstoken}` },
        }).then((res) => {
            setBranchList(res.data.response || []);
        }).catch((error) => {
            console.error("getbranchname failed:", error);
            alert(error);
        });
    };

    const fetchAllJobs = () => {
        setIsLoading(true);
        axios.get(baseurladdress + "findalljobs", {
            headers: { Authorization: `Bearer ${accesstoken}` },
        }).then((res) => {
            setTableData(res.data.response || []);
            resetSearchFields();
        }).catch((error) => {
            console.error("findalljobs failed:", error);
            alert(error);
        }).finally(() => {
            setIsLoading(false);
        });
    };

    const getSearch = () => {
        const payload = {
            ddcrecruitmentposting_location: branchname,
            ddcrecruitmentposting_jobstatus: status,
        };

        setIsLoading(true);
        fetch(`${baseurladdress}getsearch/${fromdate}/${todate}`, {
            method: "POST",
            body: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
        })
            .then((res) => res.json())
            .then((res) => {
                setTableData(Array.isArray(res.response) ? res.response : []);
                resetSearchFields();
            })
            .catch((error) => {
                console.error("getsearch failed:", error);
                alert("Search failed");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const deleteJob = (id) => {
        if (!window.confirm("Are you sure you want to delete this job?")) {
            return;
        }

        fetch(baseurladdress + `deletejobpost/${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
        }).then((response) => {
            if (response.status === 200) {
                Swal.fire("Deleted!", "The job has been deleted.", "success");
                fetchAllJobs();
            }
        }).catch((error) => {
            console.error("deletejobpost failed:", error);
            Swal.fire("Error", "Unable to delete the job.", "error");
        });
    };

    useEffect(() => {
        loadBranchOptions();
        fetchAllJobs();
    }, [accesstoken]);

    useEffect(() => {
        if (!tableRef.current || dataTableInstance.current) {
            return undefined;
        }

        const tableElement = $(tableRef.current);

        dataTableInstance.current = tableElement.DataTable({
            data: [],
            columns: [
                {
                    title: "Sl.No",
                    data: null,
                    width: "5%",
                    render: (data, type, row, meta) => meta.row + 1,
                },
                { title: "Job Title", data: "ddcrecruitmentposting_jobtitle", defaultContent: "", width: "14%" },
                {
                    title: "Job Description",
                    data: "ddcrecruitmentposting_jobdescription",
                    defaultContent: "",
                    width: "45%",
                    render: (value, type) => (type === "display" ? formatJobDescription(value) : (value || "")),
                },
                { title: "Location", data: "ddcrecruitmentposting_location", defaultContent: "", width: "10%" },
                { title: "Address", data: "ddcrecruitmentposting_address", defaultContent: "", width: "12%" },
                {
                    title: "Job Status",
                    data: "ddcrecruitmentposting_jobstatus",
                    defaultContent: "",
                    width: "7%",
                    render: (value) => {
                        if (Number(value) === 0) {
                            return '<span class="badge bg-warning">Pending</span>';
                        }
                        if (Number(value) === 1) {
                            return '<span class="badge bg-success">Publish</span>';
                        }
                        return '<span class="badge bg-danger">Onhold</span>';
                    },
                },
                {
                    title: "Edit",
                    data: "ddcrecruitmentposting_id",
                    orderable: false,
                    searchable: false,
                    width: "3.5%",
                    render: (value) => `<i class="text-primary fa fa-edit job-edit" data-id="${value}" style="cursor:pointer"></i>`,
                },
                {
                    title: "Delete",
                    data: "ddcrecruitmentposting_id",
                    orderable: false,
                    searchable: false,
                    width: "3.5%",
                    render: (value) => `<i class="text-danger fa fa-trash job-delete" data-id="${value}" style="cursor:pointer"></i>`,
                },
            ],
            pageLength: 10,
            searching: true,
            ordering: true,
            info: true,
            lengthChange: true,
            destroy: true,
            autoWidth: false,
            language: {
                emptyTable: "No data available",
                zeroRecords: "No matching records found",
            },
        });

        tableElement.on("click", ".job-edit", function () {
            const id = $(this).data("id");
            Editjobposting(id);
        });

        tableElement.on("click", ".job-delete", function () {
            const id = $(this).data("id");
            deleteJob(id);
        });

        return () => {
            tableElement.off("click", ".job-edit");
            tableElement.off("click", ".job-delete");
            if (dataTableInstance.current) {
                dataTableInstance.current.destroy();
                dataTableInstance.current = null;
            }
        };
    }, []);

    useEffect(() => {
        if (!dataTableInstance.current) {
            return;
        }

        dataTableInstance.current.clear();
        dataTableInstance.current.rows.add(tableData);
        dataTableInstance.current.draw(false);
    }, [tableData]);

    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div className="content-wrap">
                <div className="main container-fluid">
                    <section id="main-content">
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h6 className="card-title">Job Posting Details</h6>
                                <div className="d-flex align-items-center">
                                    <button
                                        type="button"
                                        className="btn plus-icon d-flex align-items-center"
                                        onClick={Jobposting}
                                        style={{ marginRight: '50px' }}
                                    >
                                        <span style={{ fontSize: "1.2rem" }}><i className='fa fa-plus-circle text-success'></i></span>
                                        <span style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}> Add</span>
                                    </button>
                                </div>
                            </div>

                            <div className="card-body">
                                <div className="row mb-3">
                                    <div className="col-md-3">
                                        <label>Opened From</label>
                                        <input type="date" className="form-control" value={fromdate} onChange={(e) => setfromdate(e.target.value)} />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Opened Till</label>
                                        <input type="date" className="form-control" value={todate} onChange={(e) => settodate(e.target.value)} />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Branch</label>
                                        <select className="form-control" value={branchname} onChange={(e) => setbranchname(e.target.value)}>
                                            <option value="">Select</option>
                                            {branchList.map((item) => (
                                                <option key={item.branch_name} value={item.branch_name}>
                                                    {item.branch_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label>Status</label>
                                        <select className="form-control" value={status} onChange={(e) => setstatus(e.target.value)}>
                                            <option value="">Select</option>
                                            <option value="0">Pending</option>
                                            <option value="1">Publish</option>
                                            <option value="2">Onhold</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="row justify-content-center mb-3">
                                    <div className="col-auto">
                                        <button type="button" className="btn btn-primary" onClick={getSearch} disabled={isLoading}>
                                            Search
                                        </button>
                                    </div>

                                    <div className="col-auto">
                                        <button className="button1 btn" type="button" data-tooltip-id="mytooltipess" onClick={fetchAllJobs} disabled={isLoading}>
                                            <i className="fa fa-refresh" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>

                                {isLoading && <div className="mb-2">Loading...</div>}

                                <div className="table-responsive">
                                    <table className="table table-bordered" id="joblist" ref={tableRef}>
                                        <thead>
                                            <tr>
                                                <th>Sl.No</th>
                                                <th>Job Title</th>
                                                <th>Job Description</th>
                                                <th>Location</th>
                                                <th>Address</th>
                                                <th>Job Status</th>
                                                <th>Edit</th>
                                                <th>Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default Joblist;
